<template>

  <div class="min-h-screen bg-gray-100">
    <header class="header">
      <div class="max-w-3xl mx-auto md:px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div class="relative flex flex-wrap items-center justify-center lg:justify-between">
          <!-- Logo -->
          <div class="absolute left-0 py-5 flex-shrink-0 lg:static">
            <router-link to="/dashboard">
              <img class="h-8 w-auto" src="http://www.mir-konkursov.ru/_media/static/images/logo2.png">
            </router-link>
          </div>

          <!-- Right section on desktop -->
          <div class="hidden lg:ml-4 lg:flex lg:items-center lg:py-5 lg:pr-0.5">
            <!--            <button type="button"
                                class="flex-shrink-0 p-1 text-cyan-200 rounded-full hover:text-white hover:bg-white hover:bg-opacity-10 focus:outline-none focus:ring-2 focus:ring-white">
                          <span class="sr-only">View notifications</span>
                          <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                               stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
                          </svg>
                        </button>-->

            <!-- Profile dropdown -->
            <!--            <ui-dropdown>
                          <template #button>
                            <button type="button"
                                    class="bg-white rounded-full flex text-sm ring-2 ring-white ring-opacity-20 focus:outline-none focus:ring-opacity-100">
                              &lt;!&ndash;                  <img class="h-8 w-8 rounded-full" :src="this.$store.getters['account/photo']" alt="user">&ndash;&gt;
                              <span class="inline-flex items-center justify-center h-8 w-8 rounded-full bg-gray-500">
                                <span class="text-sm font-medium leading-none text-white">
                                  {{ $store.getters['account/name'][0] }}
                                </span>
                              </span>
                            </button>
                          </template>
                          <ui-dropdown-item
                              @click="$router.push({name: 'UserProfile', params:{user_id: userId}})">Профиль
                          </ui-dropdown-item>
                          <ui-dropdown-item>Настройки</ui-dropdown-item>
                          <ui-dropdown-item @click="logout">Выход</ui-dropdown-item>
                        </ui-dropdown>-->
            <!-- Profile dropdown -->


            <div class="ml-3 relative">
              <ui-dropdown>
                <template #button>
                  <button class="desktop-nav-item inline-flex items-center " aria-haspopup="true">
                    <ui-avatar-circular cls="h-8 w-8" :name="name" link=""/>
                    <span class="hidden ml-3 text-sm leading-5 font-medium lg:block">
                      {{ name }}
                    </span>
                    <svg class="hidden flex-shrink-0 ml-1 h-5 w-5 lg:block"
                         viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd"/>
                    </svg>
                  </button>
                </template>
                <ui-dropdown-item @click="$router.push({name: 'UserProfile', params:{user_id: userId}})">
                  Профиль
                </ui-dropdown-item>
                <ui-dropdown-item @click="logout">Выход</ui-dropdown-item>
              </ui-dropdown>

            </div>

            <select v-model="role"
                    class="mt-1 block pl-3 text-base border-gray-300 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm rounded-md">
              <option value="user">User</option>
              <option value="admin">Admin</option>
            </select>
          </div>

          <div class="w-full py-5 lg:border-t lg:border-white lg:border-opacity-20">
            <div class="lg:grid lg:grid-cols-3 lg:gap-8 lg:items-center">
              <!-- Left nav -->
              <div class="hidden lg:block lg:col-span-2">
                <nav class="flex space-x-4">
                  <router-link v-for="i in menu" :key="i.title" :to="i.url ? i.url:''" class="desktop-nav-item">
                    {{ i.title }}
                  </router-link>
                </nav>
              </div>
              <!--
              <div class="px-12 lg:px-0">
                  &lt;!&ndash; Search &ndash;&gt;
                  <div class="max-w-xs mx-auto w-full lg:max-w-md">
                    <label for="search" class="sr-only">Search</label>
                    <div class="relative text-white focus-within:text-gray-600">
                      <div class="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center">
                        <svg class="h-5 w-5" x-description="Heroicon name: search" xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd"
                                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                clip-rule="evenodd"></path>
                        </svg>
                      </div>
                      <input id="search"
                             class="block w-full text-white bg-white bg-opacity-20 py-2 pl-10 pr-3 border border-transparent rounded-md leading-5 focus:text-gray-900 placeholder-white focus:outline-none focus:bg-opacity-100 focus:border-transparent focus:placeholder-gray-500 focus:ring-0 sm:text-sm"
                             placeholder="Search" type="search" name="search">
                    </div>
                  </div>
                </div>
                -->
            </div>
          </div>

          <!-- Menu button -->
          <div class="absolute right-0 flex-shrink-0 lg:hidden">
            <!-- Mobile menu button -->
            <button @click="open = !open"
                    class="bg-transparent p-2 rounded-md inline-flex items-center justify-center text-cyan-200 hover:text-white hover:bg-white hover:bg-opacity-10 focus:outline-none focus:ring-2 focus:ring-white"
                    aria-expanded="false">
              <span class="sr-only">Open main menu</span>
              <svg :class="{ 'hidden': open, 'block': !open }"
                   class="block h-6 w-6" xmlns="http://www.w3.org/2000/svg"
                   fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 6h16M4 12h16M4 18h16"></path>
              </svg>
              <svg :class="{ 'hidden': !open, 'block': open }"
                   class="hidden h-6 w-6" xmlns="http://www.w3.org/2000/svg"
                   fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <transition enter-active-class="duration-150 ease-out" enter-class="opacity-0" enter-to-class="opacity-100"
                  leave-active-class="duration-150 ease-in" leave-class="opacity-100" leave-to-class="opacity-0">
        <div v-if="open" class="z-20 fixed inset-0 bg-black bg-opacity-25 lg:hidden" aria-hidden="true"></div>
      </transition>

      <transition enter-active-class="duration-150 ease-out" enter-class="opacity-0 scale-95"
                  enter-to-class="opacity-100 scale-100" leave-active-class="duration-150 ease-in"
                  leave-class="opacity-100 scale-100" leave-to-class="opacity-0 scale-95">
        <div v-if="open"
             class="z-30 absolute top-0 inset-x-0 max-w-3xl mx-auto w-full p-2 transition transform origin-top lg:hidden">
          <div class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y divide-gray-200">
            <div class="pt-3 pb-2">
              <div class="flex items-center justify-between px-4">
                <div>
                  <img class="h-8 w-auto" src="https://tailwindui.com/img/logos/workflow-mark-cyan-600.svg"
                       alt="Workflow">
                </div>
                <div class="-mr-2">
                  <button @click="open = false" type="button"
                          class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-cyan-500">
                    <span class="sr-only">Close menu</span>
                    <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none"
                         viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                  </button>
                </div>
              </div>
              <div class="mt-3 px-2 space-y-1">
                <router-link v-for="i in menu" :key="i.title" :to="i.url ? i.url:''" class="mobile-nav-item">
                  {{ i.title }}
                </router-link>
              </div>
            </div>

            <div class="pt-4 pb-2">
              <div class="flex items-center px-5">
                <!--                <div class="flex-shrink-0">
                                  <img class="h-10 w-10 rounded-full" :src="this.$store.getters['account/photo']" alt="user">
                                </div>-->
                <span class="inline-flex items-center justify-center h-10 w-10 rounded-full bg-gray-500">
                  <span class="font-medium leading-none text-white">
                    {{ $store.getters['account/name'][0] }}
                  </span>
                </span>
                <div class="ml-3 min-w-0 flex-1">
                  <div class="text-base font-medium text-gray-800 truncate">
                    {{ $store.getters['account/name'] }}
                  </div>
                  <div class="text-sm font-medium text-gray-500 truncate">
                    {{ $store.getters['account/email'] }}
                  </div>
                </div>
                <button
                    class="ml-auto flex-shrink-0 bg-white p-1 text-gray-400 rounded-full hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
                  <span class="sr-only">View notifications</span>
                  <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg"
                       fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
                  </svg>
                </button>
              </div>
              <div class="mt-3 px-2 space-y-1">
                <router-link to="/user/profile" class="mobile-nav-item">Профиль</router-link>
                <router-link to="/settings" class="mobile-nav-item">Настройки</router-link>
                <a href="#" @click="logout" class="mobile-nav-item">Выход</a>
              </div>
            </div>

          </div>
        </div>
      </transition>
    </header>
    <main class="-mt-24 pb-8">
      <div class="max-w-3xl mx-auto  md:px-4 lg:max-w-7xl lg:px-8"> <!-- px-4-->
        <router-view/>
      </div>
    </main>
    <page-footer></page-footer>
  </div>


</template>

<script>
import UiDropdown from "@/components/ui/dropdown/UiDropdown";
import UiDropdownItem from "@/components/ui/dropdown/UiDropdownItem";
import PageFooter from "@/layouts/PageFooter";

import {mapGetters} from 'vuex';
import UiAvatarCircular from "@/components/ui/elements/avatars/UiAvatarCircular";

export default {
  name: 'UserLayout',
  components: {UiAvatarCircular, PageFooter, UiDropdownItem, UiDropdown},
  data: () => ({
    open: false,
    menu: [
      {
        title: 'Главная',
        url: '/dashboard'
      },
      {
        title: 'Расписание',
        url: '/events'
      },
      {
        title: 'Итоги',
        url: '/result'
      },
      {
        title: 'Архив',
        url: '/arh'
      },
      {
        title: 'Справка',
        url: '/help'
      },
      {
        title: 'Контакты',
        url: '/contact'
      }

    ],
    role: 'admin'
  }),
  computed: {
    ...mapGetters('account', {userId: 'id', name: 'name',})
  },
  methods: {
    logout() {
      this.$store.dispatch('account/logout');
      window.location.reload()
    },
  },
  watch: {
    role(value) {
      const role = localStorage.getItem('role')
      if (role !== value) {
        localStorage.setItem('role', value)
        window.location.reload()
      }
    }
  },
  mounted() {
    this.role = localStorage.getItem('role')
  }
}

</script>


<style lang="scss">
.header {
  @apply pb-24 bg-gradient-to-r from-orange-600 to-yellow-500
}

.desktop-nav-item {
  @apply text-orange-100   text-sm font-medium  rounded-md bg-white bg-opacity-0 px-3 py-2;
  &:hover {
    @apply bg-opacity-10;
  }

  &.router-link-active {
    @apply text-white;
  }
}

.mobile-nav-item {
  @apply block rounded-md px-3 py-2 text-base text-gray-900 font-medium;

  &:hover {
    @apply bg-gray-100 text-gray-800;
  }

  &.router-link-active {
    @apply bg-amber-100;
  }
}

</style>
